<template>
    <div class="section-scene org">
        <div class="org-leave">
          <img :src="static_img_url + 'pic/index/org_bg.png'">
        </div>
        <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
        <div class="org-content org-content-enter">
            <div><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></div>
            <div class="partner"><p class="gold-tle">合作伙伴</p></div>
            <div class="org-scroll-connainer">
              <div class="org-scroll" v-for="(item,index) in org_list" :key="index">
                <p  class="gold-tle" style="font-size:22px">{{item.name}}</p>
                <div class="org_list">
                  <div class="org-item" v-for="(pic,index) in item.arr" :key="index">
                    <img :src="api_img_url + pic.logo_path">
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'
export default {
    mixins:[anima_mixins],
    data(){
        return {
            static_img_url: process.env.VUE_APP_CDN,
            api_img_url: process.env.VUE_APP_APICDN,
            defaultPage: 8,

            forum_org_type: [
              {value: 1, name: "主办单位", en_name: "Organizer"},
              {value: 6, name: "联合主办", en_name: ""},
              {value: 8, name: "协办单位", en_name: "Coordinator"},
              {value: 9, name: "联合协办", en_name: ""},
              {value: 10, name: "支持机构", en_name: ""},
              {value: 7, name: "战略合作", en_name: ""},
              {value: 2, name: "合作伙伴", en_name: ""},
              {value: 3, name: "支持媒体", en_name: "Media"},
              {value: 4, name: "指导单位", en_name: ""},
              {value: 5, name: "支持协会", en_name: ""},
              {value: 11, name: "独家报名通道", en_name: ""},
              {value: 12, name: "直播支持", en_name: ""},
              {value: 13, name: "承办单位", en_name: "Co-organizer"},
              {value: 15, name: "联合承办", en_name: ""},
              {value: 14, name: "区域赛区联合主办", en_name: ""},
              {value: 16, name: "展商", en_name: ""},
              {value: 17, name: "赞助商", en_name: ""},
              {value: 18, name: "路演企业", en_name: "Roadshow"}
            ],
            org_list:[]
        }
    },
    mounted(){
      this.getOrgs()
    },
    watch:{
      activePage(n,o){ // 监听进入
        if( this.activePage == this.defaultPage ){
          this.initMousewheel()
          if( !this.org_list.length ){
            this.getOrgs()
          }
        }
      }
    },
    methods: {
      initMousewheel(){
        $('.org-scroll').mousewheel(function (event, delta) { // 阻止操作父级滚动
          event.stopPropagation();
        });
      },

      async downEnter(){
        // console.log('org: 上 进入')
        await timeoutSync(() => {
          $('.org-content').removeClass('org-content-enter')
        },100)
        await timeoutSync(() => {
            this.$emit('setLock',true)
        },600)
      },

      async upLeave(){
        this.$emit('setLock',false)
        $('.org-content').addClass('org-content-enter')
        await timeoutSync(() => {
          this.$emit('setActivePage',this.nextPage)
        },600)
      },
      getOrgs() { // 获取组织机构
				let _this = this
				$.ajax({
					type: "post",
					url: _this.apiHost + "Forum/getForumOrgRelation",
					dataType: "json",
					data: {
						uid: _this.uid
					},
					success: function (res) {
						if (res.status == '1') {
							let temp_obj = []
							let temp_arr = []
							for (let i = 0; i < res.res.length; i++) {
								let name
								let en_name
								for (let j = 0; j < _this.forum_org_type.length; j++) {
									if (_this.forum_org_type[j].value == res.res[i].type) {
										name = _this.forum_org_type[j].name
										en_name = _this.forum_org_type[j].en_name
									}
								}
								let index = temp_obj.indexOf(name)
								if (index == -1) {
									temp_obj.push(name)
									temp_arr.push({
										name: name,
										en_name: en_name,
										arr: [res.res[i]]
									})
								} else {
									temp_arr[index].arr.push(res.res[i])
								}
							}
              _this.org_list = temp_arr
						} 
					},
					error: function (e) {
            console.log('请求错误!')
					}
				})
			}
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';

.org
    background #232323
    .org-leave
      position absolute
      width 100vw
      height 100vh
      transition: all .6s
      img 
          display block
          position absolute
          width: 100%
          height 100%
          object-fit: cover
          object-position: 50% 50%
      .mask
          position relative
          z-index 2
          width 100%
          height 100%
          background:rgba(0,0,0,.6);
    .org-content
        position absolute
        z-index 10
        top px2vh(200)
        left px2vw(240)
        right px2vw(230)
        .partner
          margin-top px2vh(40)
        >div
          overflow hidden
          div,img,p
            transform translateY(0)
            transition all .6s
        &.org-content-enter
          >div
            div,img,p
              transform translateY(110%)
        .logo-vb100
            height px2vh(75)
        .org-scroll
          margin-top 39px
          height px2vh(500)
          width 100%
          overflow-x hidden
          overflow-y:scroll
          .org_list
            display flex
            flex-flow row wrap
            align-items flex-start
            margin-top:19px
            .org-item
              width 120px
              height 48px
              background #fff
              margin-top 10px
              margin-right 10px
              display flex
              align-items center
              justify-content center
              img 
                max-width: 100%;
                max-height: 100%;
                display: inline-block;
                vertical-align: middle;
.org-scroll::-webkit-scrollbar {
  width: 4px;    
}
.org-scroll::-webkit-scrollbar-thumb {
  border-radius: 3px;
  -webkit-box-shadow: inset 0 0 6px #D5D5D5;
  background: #D5D5D5;
}
.org-scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 10px #D5D5D5;
  border-radius: 5px;
  background: #313131;
}
</style>